import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router} from '@angular/router';
import { JhiLanguageService, AlertService, EventManager, ParseLinks } from 'ng-jhipster';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Rx';
import { NgbDatepickerConfig, NgbDateParserFormatter, NgbTabChangeEvent, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { ITEMS_PER_PAGE, CARD_UNLIMITED_BOOKINGS_NUMBER} from '../../shared';

import { User, UserService, CRUD_ACTIONS, BackOfficeService, Principal } from '../../shared';
import { Student, StudentComponent, StudentService, StudentUtilService } from '../../entities/student';
import { Enrollment, EnrollmentService } from '../../entities/enrollment';
import { Card, CardService } from '../../entities/card';
import { StudentComment, StudentCommentService } from '../../entities/student-comment';
import { Payment, PaymentService } from '../../entities/payment';
import { Reservation, ReservationWeek, ReservationService, PAYED_BY_CARD,
     PAYED_BY_ENROLLMENT, PAYED_PER_LESSON, ReservationStatus } from '../../entities/reservation';
import { PaymentItem, PaymentItemService } from '../../entities/payment-item';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { NgbDateFRParserFormatter } from '../../shared/calendarFomatter/ngb-date-fr-parser-formatter';
import { ReservationUtilService } from '../../entities/reservation/reservation.util.service';
import { SchoolCalendar, SchoolCalendarService} from '../../entities/school-calendar';
import { School, SchoolService} from '../../entities/school';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { EventReservationService } from '../../entities/event-reservation';
import { EventReservation } from '../../entities/event-reservation';

@Component({
    selector: 'jhi-user-mgmt-detail',
    templateUrl: './user-management-detail.component.html',
    providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }],
    styleUrls: ['./css/user-management-detail.scss']
})
export class UserMgmtDetailComponent implements OnInit, OnDestroy {

    static readonly DATE_FORMAT = 'yyyy-MM-dd';
    static readonly RESERVATION_DEFAULT_SORT = ['lesson.begining,desc'];
    login: String;
    user: User;
    student: Student;
    enrollments: Enrollment[];
    cards: Card[];
    studentComments: StudentComment[];
    paymentItemsMade: PaymentItem[];
    paymentItemsReceived: PaymentItem[];
    private currentSchool: School;
    private subscription: Subscription;
    private userSubscription: Subscription;
    private studentSubscription: Subscription;
    private enrollmentSubscription: Subscription;
    private cardSubscription: Subscription;
    private studentCommentSubscription: Subscription;
    private paymentSubscription: Subscription;
    private reservationSubscription: Subscription;
    private eventReservationSubscription: Subscription;

    // FOR THE STATUS TAB
    statusReservations: Reservation[];
    statusCalendarFrom: any;
    statusSearchFrom: Date;
    statusCalendarTo: any;
    statusSearchTo: Date;
    selectedEnrollment: Enrollment;
    reservationsPerEnrollment: number = 0;
    selectedCard: Card;
    reservationsPerCard: number = 0;
    datePipe: DatePipe = new DatePipe('UTC');

    // A Map that represents the calendar, the key is the monday of each week
    statusCalendar: Map<String, ReservationWeek>;
    // used to iterate in the template
    statusCalendarKeys: String[];
    statusCalendarMaxDate: NgbDateStruct;
    statusCalendarMinDate: NgbDateStruct;
    includeAttendedReservations: boolean;
    includeNoShowReservations: boolean;
    includeCancelledReservations: boolean;
    includeNewReservations: boolean;
    isStatusSearching: boolean;
    currencyCode: string = 'EUR'; // Euro ISO 4217 code

    // FOR THE RESERVATIONS TAB
    currentSchoolCalendar: SchoolCalendar = new SchoolCalendar();
    allReservations: Reservation[];
    totalBillableReservations: number = 0;
    totalAttendedReservations: number = 0;
    totalNoShowReservations: number = 0;
    totalNewReservations: number = 0;
    totalCancelledReservations: number = 0;
    reservationsCalendarFrom: NgbDateStruct;
    reservationsSearchFrom: Date;
    reservationsCalendarTo: NgbDateStruct;
    reservationsSearchTo: Date;
    isReservationsSearching: boolean;
    reservationsCalendarToMinDate: NgbDateStruct;
    reservationsCalendarToMaxDate: NgbDateStruct;
    // Pagination attributes (Reservations) >>
    currentReservationSearch: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    // FOR THE EVENT RESERVATIONS TAB
    allEventReservations: EventReservation[];

    // Pagination attributes (Reservations) <<
    @ViewChild('tabs')
    tabSet: NgbTabset;
    currentTab: string;

    isDesktop: boolean = window.innerWidth >= 768; // Hide tab on screens smaller than 768px

    canViewPayments: boolean = false;


    constructor(
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private userService: UserService,
        private schoolCalendarService: SchoolCalendarService,
        private studentService: StudentService,
        private studentUtilService: StudentUtilService,
        private enrollmentService: EnrollmentService,
        private cardService: CardService,
        private studentCommentService: StudentCommentService,
        private paymentService: PaymentService,
        private paymentItemService: PaymentItemService,
        private reservationService: ReservationService,
        private reservationUtilService: ReservationUtilService,
        private eventReservationService: EventReservationService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private eventManager: EventManager,
        private route: ActivatedRoute,
        private router: Router,
        private backofficeService: BackOfficeService,
        private schoolService: SchoolService
    ) {
      this.itemsPerPage = ITEMS_PER_PAGE;
      this.routeData = this.route.data.subscribe(data => {
          this.page = data['pagingParams'].page;
          this.previousPage = data['pagingParams'].page;
          this.reverse = data['pagingParams'].ascending;
          this.predicate = data['pagingParams'].predicate;
      });
      this.currentReservationSearch = route.snapshot.params['search'] ? route.snapshot.params['search'] : '';
      this.currentTab = route.snapshot.queryParams['currentTab'] ? route.snapshot.queryParams['currentTab'] : '';

      if (this.currentReservationSearch) {

        this.reservationsCalendarFrom = {
            year: parseInt(route.snapshot.params['yearFrom'], 10),
            month:  parseInt(route.snapshot.params['monthFrom'], 10),
            day:  parseInt(route.snapshot.params['dayFrom'], 10)
        };

        this.reservationsCalendarTo = {
            year: parseInt(route.snapshot.params['yearTo'], 10),
            month:  parseInt(route.snapshot.params['monthTo'], 10),
            day:  parseInt(route.snapshot.params['dayTo'], 10)
        };

    }

      this.jhiLanguageService.setLocations(studentGlobalLocations);

    }

    ngOnInit() {
        this.includeAttendedReservations = true;
        this.includeNoShowReservations = true;

        this.subscription = this.route.params.subscribe(params => {
            this.load(params['login']);
            this.loadCurrentCalendar();
        });

        this.principal.identity().then((account) => {
            this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN', 'ROLE_ADVANCED_TEACHER'])
            .then((response) => this.canViewPayments = response);
        });

        this.registerChangeInUser();
        this.registerChangeInStudent();
        this.registerChangeInEnrollments();
        this.registerChangeInCards();
        this.registerChangeInStudentComments();
        this.registerChangeInPaymentItems();
        this.registerChangeInReservations();
        this.registerChangeInEventReservations();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.isDesktop = window.innerWidth >= 768;
    }

    public onSelectChange(event: NgbTabChangeEvent) {
        this.currentTab = event.nextId;
        this.loadTab(event.nextId);
    }

    loadTab(tabId: string) {
        switch (tabId) {
            case 'user-tab':
                this.load(this.login);
            break;
            case 'student-tab':
                this.loadStudent();
            break;
            case 'status-tab':
                this.loadStudent();
                this.loadStatus();
            break;
            case 'reservation-tab':
                this.loadReservations(true);
            break;
            case 'event-reservation-tab':
                this.loadEventReservations();
            break;
            case 'enrollment-tab':
                this.loadEnrollments();
            break;
            case 'card-tab':
                this.loadCards();
            break;
            case 'student-comment-tab':
                this.loadStudentComments();
            break;
            case 'payment-received-tab':
                this.loadPaymentsReceived();
            break;
            case 'payment-made-tab':
                this.loadPaymentsMade();
            break;
           }
    }

    load(login) {
        this.userService.find(login).subscribe(res  => {
            this.login = login;
            this.user = res;
            this.loadStudent();
            this.schoolService.findCurrent()
                              .subscribe(school => this.currentSchool = school
                                , e => this.onError(e));
        });
    }

    loadStudent() {
        this.studentService.search({
            query: 'user.id:' + this.user.id,
        }, true)
        .subscribe((res: HttpResponse<Student[]>) => this.onStudentSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res.error) );
    }

    loadStatus() {
        if (this.student && this.student.status) {
            this.statusCalendarMinDate = this.fromDate(new Date(2000, 1, 1));
            this.statusCalendarMaxDate = this.fromDate(new Date(2030, 1, 1));

            if (this.student.status['activeProduct'] === null) {
                this.loadStatusReservations(true);
                return;
            }

           if (this.student.status['activeProduct']['name'] === 'CARD') {
                this.cardService.search({
                    query: 'id:' + this.student.status['activeProduct']['id']
                }).subscribe(
                    (res: HttpResponse<Card[]>) => {
                        this.selectedCard = res.body[0];
                        this.loadStatusReservations(true);
                    },
                    (res: HttpErrorResponse) => this.onError(res));
            }
        }
    }

    loadEnrollments() {
    }

    loadCards() {
        this.cardService.search({
            query: 'student.id:' + this.student.id,
            sort: ['validSince,desc']
        }).subscribe(
            (res: HttpResponse<Card[]>) => this.onCardsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    loadStudentComments() {
        this.studentCommentService.search({
            query: 'student.id:' + this.student.id,
            sort: ['createdDate,desc']
        }).subscribe(
            (res: HttpResponse<StudentComment[]>) => this.onStudentCommentsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    loadPaymentsMade() {
        this.paymentService.search({
            query: 'payer.id:' + this.student.id,
            sort: ['paymentDate,desc']
        }).subscribe(
            (res: HttpResponse<Payment[]>) => this.onPaymentsMadeSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    loadPaymentsReceived() {
        this.paymentItemService.search({
            query: 'beneficiary.id: ' + this.student.id,
            sort: ['payment.paymentDate,desc']
        }).subscribe(
            (res: HttpResponse<Payment[]>) => this.onPaymentItemsReceivedSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    loadReservations(resetDates: boolean) {
        this.initReservationsCalendar(resetDates);

        this.currentReservationSearch = 'student.id:' + this.student.id + ' AND '
                             + this.getDateRangeQuery(this.reservationsSearchFrom, this.reservationsSearchTo);

        let searchParams = this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo);

        let params = {
            query: this.currentReservationSearch,
            sort: UserMgmtDetailComponent.RESERVATION_DEFAULT_SORT,
            size: this.itemsPerPage,
            currentTab: this.currentTab,
            ...searchParams
        };

        this.reservationService.search(params).subscribe(
            (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );

        this.loadReservationsCount();
    }

    loadEventReservations() {
        this.eventReservationService.search({
            query: 'student.id:' + this.student.id,
            sort: ['event.begining,desc']
        }).subscribe(
            (res: HttpResponse<EventReservation[]>) => this.onEventReservationSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private loadReservationsCount() {
        if (!this.currentReservationSearch) {
            return;
        }
        // count the new reservations
        let countNewReservationsQuery: string = '!(lesson.free:true) AND status:NEW ' + this.currentReservationSearch;
        this.reservationService.count({query : countNewReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalNewReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );

        // count the attended reservations
        let countAttendedReservationsQuery: string = '!(lesson.free:true) AND status:ATTENDED ' + this.currentReservationSearch;
        this.reservationService.count({query : countAttendedReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalAttendedReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );

         // count the no show reservations
        let countNoShowReservationsQuery: string = '!(lesson.free:true) AND status:NO_SHOW ' + this.currentReservationSearch;
        this.reservationService.count({query : countNoShowReservationsQuery})
                                .subscribe(
                                 (res: number) => this.totalNoShowReservations = res,
                                 (res: HttpErrorResponse) => this.onError(res)
                                 );
        // count the cancelled reservations ( cancelled by the user or by cancelling a lesson)
        let countCancelledReservationsQuery: string =
        '!(lesson.free:true) AND (status:CANCELLED OR status:LESSON_CANCELLED) ' + this.currentReservationSearch;
        this.reservationService.count({query : countCancelledReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalCancelledReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );
        // count the billable reservations
        let countTotalBillableReservationsQuery: string = '!(lesson.free:true) AND '
        + ' !(status:CANCELLED) !(status:LESSON_CANCELLED) AND ' + this.currentReservationSearch;
        this.reservationService.count({query : countTotalBillableReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalBillableReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );

    }

    getDateSearchParams(searchDateFrom: NgbDateStruct, searchDateTo: NgbDateStruct) {
        let result: any = {};

        if (searchDateFrom) {
            result.yearFrom = searchDateFrom.year;
            result.monthFrom = searchDateFrom.month;
            result.dayFrom = searchDateFrom.day;
        }

        if (searchDateTo) {
            result.yearTo = searchDateTo.year;
            result.monthTo = searchDateTo.month;
            result.dayTo = searchDateTo.day;
        }

        return result;
    }

    loadAllReservations() {
        if (this.currentReservationSearch) {
            this.reservationService.search({
                page: this.page - 1,
                query: this.currentReservationSearch,
                size: this.itemsPerPage,
                sort: UserMgmtDetailComponent.RESERVATION_DEFAULT_SORT,
            }).subscribe(
                (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
                );
            return;
        }
        this.reservationService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: UserMgmtDetailComponent.RESERVATION_DEFAULT_SORT,
        }).subscribe(
            (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (!this.predicate) {
            result.push('id');
        }
        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/user-management/' + this.login], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentReservationSearch,
                sort: UserMgmtDetailComponent.RESERVATION_DEFAULT_SORT,
                currentTab: this.currentTab,
                ...this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo)
            }
        });
        this.loadAllReservations();
    }

    loadStatusReservations(resetDates: boolean) {
        this.initStatusCalendar(resetDates);

        let filters: string[] = [];
        if (this.includeAttendedReservations) {
            filters.push('ATTENDED');
        }

        if (this.includeNoShowReservations) {
            filters.push('NO_SHOW');
        }

        if (this.includeCancelledReservations) {
            filters.push('CANCELLED');
        }

        if (this.includeNewReservations) {
            filters.push('NEW');
        }

        let statusClause: string;
        if (filters.length > 0) {
            statusClause = 'AND status:(';
            let nextOperator: number = 0;
            filters.forEach(s => {
                statusClause = statusClause + ((nextOperator > 0 ? ' OR ' + s : s));
                if (nextOperator === (filters.length - 1)) {
                    statusClause = statusClause + ')';
                }
                nextOperator++;
            });
        } else {
            statusClause = ' ';
        }

        this.reservationService.search({
            query: 'student.id:' + this.student.id + ' AND ' +
            this.getDateRangeQuery(this.statusSearchFrom, this.statusSearchTo) +
            statusClause
        }).subscribe(
            (res: HttpResponse<Reservation[]>) => this.onStatusReservationsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    registerChangeInUser() {
        this.userSubscription =
             this.eventManager.subscribe('userListModification',
                                (event) => {
                                    if (!event || !event['content']) {
                                        return;
                                    }
                                    this.refreshUser(event['content']['content']);
                                } );
    }

    registerChangeInStudent() {
        this.studentSubscription =
             this.eventManager.subscribe('studentModification',
                                (event) => {
                                    if (!event || !event['content']) {
                                        return;
                                    }
                                    this.refreshStudent(false,  event['content']['content']);
                                });
    }

    registerChangeInEnrollments() {
        this.enrollmentSubscription = this.eventManager
                                          .subscribe('enrollmentListModification',
                                          (event) => {
                                            if (!event || !event['content']) {
                                                return;
                                            }
                                            let entity: any = event['content']['content'];
                                            let action: String = event['content']['action'];
                                            this.refreshList(entity, action, this.enrollments,
                                                (e: Enrollment) => new Date(e.validSince) < new Date(entity.validSince));
                                          });
    }

    registerChangeInCards() {
        this.cardSubscription = this.eventManager
                                    .subscribe('cardListModification',
                                    (event) => {
                                        if (!event || !event['content']) {
                                            return;
                                        }
                                        let entity: any = event['content']['content'];
                                        let action: String = event['content']['action'];
                                        this.refreshList(entity, action, this.cards,
                                            (c: Card) => new Date(c.validSince) < new Date(entity.validSince));
                                    });
    }

    registerChangeInStudentComments() {
        this.studentCommentSubscription = this.eventManager
                                    .subscribe('StudentCommentListModification',
                                    (event) => {
                                        if (!event || !event['content']) {
                                            return;
                                        }
                                        let entity: any = event['content']['content'];
                                        let action: String = event['content']['action'];
                                        this.refreshList(entity, action, this.studentComments,
                                            (c: StudentComment) => c.id < entity.id);
                                    });
    }

    registerChangeInPaymentItems() {
        this.paymentSubscription = this.eventManager
            .subscribe('paymentItemListModification',
            (event) => {
                if (!event || !event['content']) {
                    return;
                }
                let entity: any = event['content']['content'];
                let action: String = event['content']['action'];

                // We refresh the payments tabs
                if (this.paymentItemsReceived) {
                    this.refreshList(entity, action, this.paymentItemsReceived,
                        (p: PaymentItem) => new Date(p.payment.paymentDate) < new Date(entity.payment.paymentDate));
                }
                if (this.paymentItemsMade) {
                    this.refreshList(entity, action, this.paymentItemsMade,
                        (p: PaymentItem) => new Date(p.payment.paymentDate) < new Date(entity.payment.paymentDate));
                }
            });
    }

    registerChangeInReservations() {
        this.reservationSubscription = this.eventManager
                                           .subscribe('reservationListModification',
                                            (event) => {

                                                if (!event || !event['content']) {
                                                    return;
                                                }

                                                let entity: any = event['content']['content'];
                                                let action: String = event['content']['action'];
                                                let sortFunction: any =  (r: Reservation) => {
                                                    let reservationDate: Date = new Date(entity.lesson.begining);

                                                    if (this.reservationsSearchFrom <= reservationDate &&
                                                        this.reservationsSearchTo >= reservationDate) {
                                                            return new Date(r.lesson.begining) < reservationDate;
                                                        }
                                                    return false;
                                                };
                                                this.refreshList(entity, action, this.allReservations, sortFunction);
                                                this.loadReservationsCount();
                                            });
    }

    registerChangeInEventReservations() {
        this.eventReservationSubscription = this.eventManager
                                           .subscribe('eventParticipantsListModification',
                                            (event) => {

                                                if (!event || !event['content']) {
                                                    return;
                                                }

                                                let entity: any = event['content']['content'];
                                                let action: String = event['content']['action'];
                                                let sortFunction: any =  (r: EventReservation) => {
                                                    let reservationDate: Date = new Date(entity.event.begining);
                                                    return new Date(r.event.begining) < reservationDate;
                                                };
                                                this.refreshList(entity, action, this.allEventReservations, sortFunction);

                                            });
    }

    private reservationCalendarfromDateChanged(fromDate: NgbDateStruct) {
        if (!fromDate) {
            return;
        }

        // We set the min date of the toCalendar the same date fromDate
        let minDate: Date = new Date(fromDate.year, fromDate.month - 1, fromDate.day);
        this.reservationsCalendarToMinDate = {
            year: minDate.getFullYear(),
            month: minDate.getMonth() + 1,
            day: minDate.getDate()
        };

        // We set the max date of the toCalendar to 2 year from the fromDate
        let maxDate: Date = new Date(fromDate.year, fromDate.month - 1 + (12 * 2) , fromDate.day);
        this.reservationsCalendarToMaxDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate()
        };
    }

    private refreshList(entity: any, action: String, list: any[], sortFunction?: any) {
        if (action === CRUD_ACTIONS.CREATE) {
            // We have to insert the item in the correct index based on the given sort function
            let i: number = sortFunction ? list.findIndex(sortFunction) : -1;
            if (i >= 0) {
                list.splice(i, 0, entity);
            } else {
                list.push(entity);
            }
            return;
        }

        list.forEach((item, i) => {
            if (item.id === entity.id) {
                if (action === CRUD_ACTIONS.UPDATE) {
                    list[i] = entity;
                } else {
                    list.splice(i, 1);
                }
            }
        });
    }

    private refreshStudent(fromBackend: boolean, entity: any) {
        if (fromBackend) {
            this.studentService.search({
                query: 'user.id:' + this.user.id,
            }, true)
            .subscribe((res: HttpResponse<Student[]>) => {
                    this.student = res.body[0];
                },
                (res: HttpErrorResponse) => {
                    return this.onError(res);
                });

            return;
        }

        this.student = entity;
    }

    private refreshUser(entity: any) {
        this.user = entity;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.userSubscription.unsubscribe();
        this.studentSubscription.unsubscribe();
        this.enrollmentSubscription.unsubscribe();
        this.cardSubscription.unsubscribe();
        this.studentCommentSubscription.unsubscribe();
        this.paymentSubscription.unsubscribe();
        this.reservationSubscription.unsubscribe();
        this.eventReservationSubscription.unsubscribe();
    }

    previousState() {
        window.history.back();
    }

    public statusSearch() {
        this.isStatusSearching = true;
        this.loadStatusReservations(false);
    }

    public clearStatusSearch() {
        this.isStatusSearching = false;
        this.includeAttendedReservations = true;
        this.includeNoShowReservations = false;
        this.includeCancelledReservations = false;
        this.includeNewReservations = false;
        this.loadStatusReservations(true);
    }

    public reservationsSearch() {
        this.isReservationsSearching = true;
        this.page = 0;

        let dateSearchParams = this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo);

        this.router.navigate(['/user-management/' + this.login, {
            search: this.currentReservationSearch,
            page: this.page,
            sort: UserMgmtDetailComponent.RESERVATION_DEFAULT_SORT,
            currentTab: this.currentTab,
            ...dateSearchParams
        }]);

        this.loadReservations(false);
    }

    public clearReservationsSearch() {
        this.isReservationsSearching = false;
        this.page = 0;
        this.currentReservationSearch = '';
        this.reservationsCalendarFrom = null;
        this.reservationsCalendarTo = null;
        this.loadReservations(true);
    }


    private onStudentSuccess(data, headers) {
        this.student = data[0];

        if (this.student) {
            // Remove the currency symbol if there is no active product
            // TODO: Remove once totalPaid and total reflects always amounts
            if (!this.student.status.activeProduct) {
                this.currencyCode = '';
            }

        }
        if (this.currentTab && this.tabSet) {
            this.tabSet.select(this.currentTab);
        }
    }

    public getStatusBadgeStyle(percentage: number): string {
        return this.studentUtilService.getStatusBadgeStyle(percentage);
    }

    public getAuthorityBadgeStyle(authority: string): string {
        return this.studentUtilService.getAuthorityBadgeStyle(authority);
    }

    getReservationBadgeStyle(reservation: Reservation): String {
        if (reservation) {
            return this.reservationUtilService.getReservationBadgeStyle(
                reservation.status.toString());
        }
        return 'badge-info';
    }

    getStudentCommentBadgeStyle(comment: StudentComment): String {
        if (comment) {
            return this.studentCommentService.getStudentCommentBadgeStyle(
                comment.type.toString());
        }
        return 'badge-info';
    }

    getStudentCommentStatusBadgeStyle(comment: StudentComment): String {
        if (comment) {
            return this.studentCommentService.getStudentCommentStatusBadgeStyle(
                comment.status.toString());
        }
        return 'badge-info';
    }

    createCheckoutSession(reservation: Reservation) {
        this.backofficeService
            .createCheckoutSession(reservation.school, reservation.id)
            .subscribe( (res: string) => {
                this.onReservationCheckoutCreated(res);
            } , (error: Response) => console.log('Error creating the checkout session'));
    }

    private belongsToProduct(reservation: Reservation) {
        return reservation.lesson.free === true || this.reservationUtilService.belongsToProduct(reservation);
    }

    private getPaymentMethod(reservation: Reservation) {
        return this.reservationUtilService.getPaymentMethod(reservation);
    }

    private getPayedByProductIcon() {
        return this.reservationUtilService.getPayedByProductIcon();
    }

    private getNotPayedByProductIcon() {
        return this.reservationUtilService.getNotPayedByProductIcon();
    }

    getMaxAssistances() {
        return CARD_UNLIMITED_BOOKINGS_NUMBER;
    }

    private onEnrollmentsSuccess(data, headers) {
        this.enrollments = data;
    }

    private onCardsSuccess(data, headers) {
        this.cards = data;
    }

    private onStudentCommentsSuccess(data, headers) {
        this.studentComments = data;
    }

    private onPaymentsMadeSuccess(data, headers) {
        let payments: Payment[] = data;

        if (payments.length === 0) {
            this.paymentItemsMade = [];

            return;
        }
        let paymentIds = '';
        payments.forEach((payment, index) => {
            paymentIds = paymentIds + payment.id + ((index < payments.length - 1) ? ' OR ' : '');
        });

        this.paymentItemService.search({
            query: 'payment.id:(' + paymentIds + ')',
            sort: ['payment.paymentDate,desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onPaymentItemsMadeSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private onStatusReservationsSuccess(data, headers) {
        this.statusReservations = data;
        this.refreshStatusMatrix();
    }

    private onReservationCheckoutCreated(chechoutUrl: string) {
        // we open the checkout session in same browser so the user can pay
         window.location.href = chechoutUrl;
    }

    private isOnlinePaymentsEnabled() {
        return this.backofficeService.isOnlinePaymentsEnabled(this.currentSchool);
    }

    private refreshStatusMatrix() {
        this.reservationsPerCard = 0;
        this.reservationsPerEnrollment = 0;

        if (this.statusCalendar !== null) {
            this.statusReservations.forEach(r => {
                // We calculate the monday that corresponds to the lesson of the reservation
                let begining = r['lesson']['begining'];
                let lessonDate: Date = begining !== null ? new Date(begining) : null;
                let lessonDay = lessonDate !== null ? lessonDate.getDay() : null;
                let monday: Date = lessonDay !== null ? new Date(lessonDate) : null;
                if (monday !== null) {
                    switch (lessonDay) {
                        case 0:
                            monday.setDate(monday.getDate() - 6);
                            break;
                        case 1:
                            // We do nothing cause the date is already monday
                            break;
                        default:
                            monday.setDate(monday.getDate() - (lessonDay === 1 ? 0 : lessonDay - 1));
                    }

                    // We get the day from the calendarMap
                    let reservationWeek: ReservationWeek = this.statusCalendar
                        .get(this.datePipe
                            .transform(monday, UserMgmtDetailComponent.DATE_FORMAT));
                    if (reservationWeek) {
                        let reservationsCount = reservationWeek.reservations;
                        if (reservationsCount) {
                            lessonDay = lessonDay === 0 ? 6 : lessonDay - 1;
                            reservationsCount[lessonDay] = reservationsCount[lessonDay] + 1;
                        }
                    }
                }

                // We calculate the number of reservations depending on the dates of the enrrollment/card
                if (this.selectedEnrollment && this.selectedEnrollment.validSince <= lessonDate
                    && this.selectedEnrollment.validUntil >= lessonDate) {
                    this.reservationsPerEnrollment++;
                }

                if (this.selectedCard && this.selectedCard.validSince <= lessonDate && this.selectedCard.validUntil >= lessonDate) {
                    this.reservationsPerCard++;
                }
            });
        }
    }

    private onReservationSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.allReservations = data;
    }

    private onEventReservationSuccess(data, headers) {
        this.allEventReservations = data;
    }

    private onPaymentItemsMadeSuccess(data, headers) {
        this.paymentItemsMade = data;
    }

    private onPaymentItemsReceivedSuccess(data, headers) {
        this.paymentItemsReceived = data;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    private initStatusCalendar(resetDates: boolean) {
        let fromDate: Date;
        let toDate: Date;

        // We initialize the UI filters.
        if (resetDates) {
            // If there is a current school calendar we use it
            if (this.currentSchoolCalendar) {
                fromDate = new Date(this.currentSchoolCalendar.begining);
                toDate = new Date(this.currentSchoolCalendar.ending);
                this.statusCalendarFrom = this.fromDate(fromDate);
                this.statusCalendarTo = this.fromDate(toDate);
            } else {
                // We initialize the FROM date with 3 months before the TO date or the min date of the calendar
                toDate = new Date();
                fromDate = new Date();
                fromDate.setDate(toDate.getDate() - 30 * 3);
                this.statusCalendarFrom = this.fromDate(fromDate);
                this.statusCalendarTo = this.fromDate(toDate);
            }
        } else {
            fromDate = this.toDate(this.statusCalendarFrom);
            toDate = this.toDate(this.statusCalendarTo);
        }

        // We initialize the TO date with the sunday of the week of TO DATE.
        let lastDay = toDate.getDay();
        this.statusSearchTo = new Date(toDate);
        this.statusSearchTo.setDate(toDate.getDate() + (lastDay === 0 ? 0 : 7 - lastDay));

        // We initialize the FROM date with the monday  of week of the FROM DATE
        this.statusSearchFrom = new Date(fromDate);
        let firstDay = fromDate.getDay();
        this.statusSearchFrom.setDate(fromDate.getDate() - (firstDay === 1 ? 0 : firstDay - 1));

        // We initialize the reservations calendar
        let currentSunday = new Date(this.statusSearchTo);
        this.statusCalendar = new Map();
        this.statusCalendarKeys = [];
        while (currentSunday > this.statusSearchFrom) {
            let lastMonday: Date = new Date(currentSunday);
            lastMonday.setDate(lastMonday.getDate() - 6);

            let key: String = this.datePipe.transform(lastMonday, UserMgmtDetailComponent.DATE_FORMAT);
            this.statusCalendar
                .set(key,
                new ReservationWeek(new Date(lastMonday), [0, 0, 0, 0, 0, 0, 0]));
            this.statusCalendarKeys.push(key);

            currentSunday.setDate(currentSunday.getDate() - 7);
        }
    }

    private initReservationsCalendar(resetDates: boolean) {
        let fromDate: Date;
        let toDate: Date;

        // We initialize the UI filters.
        if (resetDates) {

            if (!this.reservationsCalendarFrom && !this.reservationsCalendarTo) {
                // If there is a current school calendar we use it
                if (this.currentSchoolCalendar) {
                    fromDate = new Date(this.currentSchoolCalendar.begining);
                    toDate = new Date(this.currentSchoolCalendar.ending);
                    this.reservationsCalendarFrom = this.fromDate(fromDate);
                    this.reservationsCalendarTo = this.fromDate(toDate);
                } else {
                    // We initialize the FROM date with 7 days before the TO date or the min date of the calendar
                    toDate = new Date();
                    fromDate = new Date();
                    fromDate.setDate(toDate.getDate() - 7);
                    this.reservationsCalendarFrom = this.fromDate(fromDate);
                    this.reservationsCalendarTo = this.fromDate(toDate);
                }
            } else {
                fromDate = this.toDate(this.reservationsCalendarFrom);
                toDate = this.toDate(this.reservationsCalendarTo);
            }

        } else {
            fromDate = this.toDate(this.reservationsCalendarFrom);
            toDate = this.toDate(this.reservationsCalendarTo);
        }

        this.reservationsSearchFrom = new Date(fromDate);
        this.reservationsSearchTo = new Date(toDate);

    }

    private getDateRangeQuery(from: Date, to: Date) {
        let dayFrom = from.getDate();
        let monthFrom = from.getMonth() + 1;
        let dayTo = to.getDate();
        let monthTo = to.getMonth() + 1;

        let realDayFrom = dayFrom < 10 ? '0' + dayFrom : dayFrom;
        let realMonthFrom = monthFrom < 10 ? '0' + monthFrom : monthFrom;
        let realDayTo = dayTo < 10 ? '0' + dayTo : dayTo;
        let realMonthTo = monthTo < 10 ? '0' + monthTo : monthTo;

        return 'lesson.begining:[' + from.getFullYear() + '-' + realMonthFrom + '-' + realDayFrom +
            ' TO ' + to.getFullYear() + '-' + realMonthTo + '-' + realDayTo + ']';
    }

    private toDate(jsonDate: Object): Date {
        if (jsonDate !== null) {
            let year = jsonDate['year'];
            let month = jsonDate['month'];
            let day = jsonDate['day'];

            if (year != null && month != null && day != null) {
                let d = new Date();
                d.setDate(day);
                d.setFullYear(year);
                d.setMonth(month - 1);

                return d;
            }
        }

        return null;
    }

    private fromDate(date: Date): NgbDateStruct {
        if (date) {
            return {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            };
        }

        return {
            day: 18,
            month: 3,
            year: 1951
        };
    }

    private loadCurrentCalendar() {
        this.schoolCalendarService
        .current()
        .subscribe(
            (res: HttpResponse<SchoolCalendar[]>) => {
                let calendars = res.body;
                if (calendars.length > 0 ) {
                    this.currentSchoolCalendar = calendars[0];
                } else {
                    this.currentSchoolCalendar = null;
                }

            },
            (res: HttpErrorResponse) => this.onError(res));
    }

    getAvailableAssistances(card: Card): number {
        return this.cardService.getAvailableAssistances(card);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management-detail.component.ts